/**
 * @author Sumit Majumdar
 * @email sumit@grexit.com
 * @create date 2018-03-28 11:26:31
 * @modify date 2018-03-28 11:26:31
 * @desc [description]
*/

/**
 * Maps connector type to url prefix for the connector operation
 */
export const typePrefixMap = {
    'slack-connector': '/slack'
}
/**
 * maps connector type and its response fields with connectors redux store format
 */
export const typeDataMap = {
    'slack-connector': {
        checkboxOptions: 'types',
        selectedValue: 'channel'
    }
}
export const TOGGLE_CONNECTOR_CHECKBOX = 'TOGGLE_CONNECTOR_CHECKBOX'
export const FETCH_CONNECTOR_INIT = 'FETCH_CONNECTOR_INIT'
export const FETCH_CONNECTOR_DONE = 'FETCH_CONNECTOR_DONE'
export const FETCH_CONNECTOR_FAILED = 'FETCH_CONNECTOR_FAILED'
export const SETUP_CONNECTOR_INIT = 'SETUP_CONNECTOR_INIT'
export const SETUP_CONNECTOR_DONE = 'SETUP_CONNECTOR_DONE'
export const SETUP_CONNECTOR_FAILED = 'SETUP_CONNECTOR_FAILED'
export const SAVE_CONNECTOR_TYPE_INIT = 'SAVE_CONNECTOR_TYPE_INIT'
export const SAVE_CONNECTOR_TYPE_DONE = 'SAVE_CONNECTOR_TYPE_DONE'
export const SAVE_CONNECTOR_TYPE_FAILED = 'SAVE_CONNECTOR_TYPE_FAILED'
export const FETCH_CONNECTOR_CHANNELS_INIT = 'FETCH_CONNECTOR_CHANNELS_INIT'
export const FETCH_CONNECTOR_CHANNELS_FAILED = 'FETCH_CONNECTOR_CHANNELS_FAILED'
export const FETCH_CONNECTOR_CHANNELS_DONE = 'FETCH_CONNECTOR_CHANNELS_DONE'
export const DISABLE_CONNECTOR_INIT = 'DISABLE_CONNECTOR_INIT'
export const DISABLE_CONNECTOR_DONE = 'DISABLE_CONNECTOR_DONE'
export const DISABLE_CONNECTOR_FAILED = 'DISABLE_CONNECTOR_FAILED'
export const TOGGLE_CONNECTOR_ENABLED = 'TOGGLE_CONNECTOR_ENABLED'
